import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '@/api/index';
import { CLIENT_URL } from '@/constants/index';

export const supportApi = createApi({
  reducerPath: 'supportApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Support'],
  endpoints: (builder) => ({
    postComment: builder.mutation({
      query: (data) => ({
        baseURL: CLIENT_URL,
        url: 'comments/',
        method: 'POST',
        data,
      }),
    }),
  }),
});

export const hooks = {
  usePostComment: supportApi.usePostCommentMutation,
};

export default supportApi;
